import { useContext } from 'react';
import { BaseLoanTypeStore } from '../stores/baseLoanTypeStore';
import { LoanTypeStoreContext } from '../utils/loanTypeStoreContext';

interface LoanTypeStoreHook {
  loanTypeStore: BaseLoanTypeStore;
}

export const useLoanTypeStore = (): LoanTypeStoreHook => {
  const loanTypeStore = useContext(LoanTypeStoreContext);
  return { loanTypeStore };
};
